import {createContext} from 'react'
import {GlobalStorage} from './Global.storage';

let globalStorage = new GlobalStorage;
export {
    globalStorage
}
export const storeContext = createContext({
    globalStorage: globalStorage
})
